import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CONSTANTS } from '../../data';
import { sounds } from '../../systems/AudioSystem';

interface SaveConfirmationModalProps {
  isOpen: boolean;
  isWarningVisible: boolean;
  onSaveAndExit: () => void;
  onExitWithoutSaving: () => void;
  onConfirmExitWithoutSaving: () => void;
  onCancel: () => void;
}

export const SaveConfirmationModal: React.FC<SaveConfirmationModalProps> = ({
  isOpen,
  isWarningVisible,
  onSaveAndExit,
  onExitWithoutSaving,
  onConfirmExitWithoutSaving,
  onCancel,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="reset-overlay" // Reusing styles
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="reset-modal" // Reusing styles, but with cyan theme
            style={{
              borderColor: isWarningVisible ? '#ff0000' : '#00ffff',
              background: 'linear-gradient(135deg, #1a1a2e 0%, #0f0f1e 100%)',
              boxShadow: isWarningVisible ? '0 0 50px rgba(255, 0, 0, 0.7)' : '0 0 50px rgba(0, 255, 255, 0.7)',
            }}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            {!isWarningVisible ? (
              <>
                <h2 className="reset-title" style={{ color: '#00ffff', textShadow: '0 0 20px rgba(0, 255, 255, 0.8)' }}>
                  {CONSTANTS.SAVE_CONFIRMATION.title}
                </h2>
                <p className="reset-text">{CONSTANTS.SAVE_CONFIRMATION.message}</p>
                <div className="reset-buttons" style={{ flexDirection: 'column', gap: '1rem' }}>
                  <button
                    className="reset-confirm-btn"
                    style={{ background: 'linear-gradient(135deg, #00ff00, #00aa00)', borderColor: '#00ff00', boxShadow: '0 0 20px rgba(0, 255, 0, 0.5)' }}
                    onClick={onSaveAndExit}
                    onMouseEnter={() => sounds.menuHover()}
                  >
                    {CONSTANTS.SAVE_CONFIRMATION.saveButtonText}
                  </button>
                  <button
                    className="reset-confirm-btn"
                    onClick={onExitWithoutSaving}
                    onMouseEnter={() => sounds.menuHover()}
                  >
                    {CONSTANTS.SAVE_CONFIRMATION.exitButtonText}
                  </button>
                  <button className="reset-cancel-btn" onClick={onCancel} onMouseEnter={() => sounds.menuHover()}>
                    {CONSTANTS.SAVE_CONFIRMATION.cancelButtonText}
                  </button>
                </div>
              </>
            ) : (
              <>
                <h2 className="reset-title" style={{ color: '#ff0000', textShadow: '0 0 20px rgba(255, 0, 0, 0.8)' }}>
                  {CONSTANTS.SAVE_CONFIRMATION.warningTitle}
                </h2>
                <p className="reset-text">{CONSTANTS.SAVE_CONFIRMATION.warningMessage}</p>
                <div className="reset-buttons">
                  <button className="reset-cancel-btn" onClick={onCancel} onMouseEnter={() => sounds.menuHover()}>
                    {CONSTANTS.SAVE_CONFIRMATION.cancelButtonText}
                  </button>
                  <button className="reset-confirm-btn" onClick={onConfirmExitWithoutSaving} onMouseEnter={() => sounds.menuHover()}>
                    {CONSTANTS.SAVE_CONFIRMATION.confirmExitButtonText}
                  </button>
                </div>
              </>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
